import type { RestaurantDetails } from './apiHelpers';
import styles from './SubNav.scss';
import { SubNavLink } from './SubNavLink';
import { useGuestLandingPaths } from 'webReservations/hooks/useGuestLandingPaths';

interface SubNavProps {
  restaurant: RestaurantDetails;
}

export const SubNav = ({ restaurant }: SubNavProps) => {
  const { legacyRestaurantBasePath } = useGuestLandingPaths();
  const restaurantPath = legacyRestaurantBasePath(restaurant);
  const seatingPath = restaurantPath;
  const aboutPath = `${restaurantPath}/about`;

  return (
    <div className={styles.subNav}>
      <SubNavLink to={seatingPath}>Seating</SubNavLink>
      <SubNavLink to={aboutPath}>About</SubNavLink>
    </div>
  );
};
